import { getConfig } from "@jti/fe-common";

import { getUser } from "../../utils";

import type { QuizApiContract } from "./QuizApiEvo";
import { QuizApiEvo } from "./QuizApiEvo";

const user = getUser();

export class QuizApi {
  static init(): QuizApiContract {
    const config = getConfig();
    return new QuizApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, user.ciam_token, config["X-RECAPTCHA-ID"]);
  }
}
